import { render, staticRenderFns } from "./DeleteStaffDialog.vue?vue&type=template&id=38a1c7f7&scoped=true&"
import script from "./DeleteStaffDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteStaffDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a1c7f7",
  null
  
)

export default component.exports